<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
export default {
    components: { SvgTransition },
    data() {
        return {
            
        }
    },
    created() {  
        this.$cache.createCache('publicPage', 'public-page/',  {id: this.$route.params.id, domain: window.location.hostname });  
       
    },
    computed: {
        url() { return config.urlToServer },  
        publicPageColorsDict() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColorsDict : null },         
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },
        applications() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.openApplications : [] },
        settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
        hasSettings() { return this.settings != null },
    },
    methods:
    {
        goTopage(item)
        {
            $(window).scrollTop(0);           
            this.$router.push({ name: niceFunctions.getPageName('openApplicationDetails'), params: { id: this.$route.params.id, applicationid: item.id } })
        } ,
        blurOut(item)
        {
            if(this.applications.filter(x => x.hovered) == 0) {
                return false;
            }
            else if(item.hovered) {
                return false;
            }
            return true;
        }       
    }   
}
</script>
<template>
   <section  class="public-page" v-if="publicPage != null && settings != null">   
        <div class="text-section" style="padding-top: 70px;min-height:1000px">
            <h1 :style="publicPageColorsDict.header_color_on_white_bg.style" class="margin-top-70">{{ settings.OpenApplication.plural }}</h1>     
            <div class="OpenApplications-wrapper">
                <div v-for="application in applications" class="OpenApplications-course-item"> 
                    <div @mouseover="application.hovered = true" @mouseout="application.hovered = false" :class="blurOut(application) ? 'ImageGallery-grayscale' : 'ImageGallery-no-grayscale'" >
                        <div class="position-relative">
                            <div class="OpenApplications-course-img-area">
                                <img v-if="application.image_id" :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ application.image_name" />  
                                <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                            </div>
                            <h4 :style="{'background-color': publicPageColorsDict.background_color.color }">{{ application.title }}</h4>
                        </div>
                        <div class="OpenApplications-description">
                            <i v-html="application.description">

                            </i>
                            
                            <button class="OpenApplications-btn float-right margin-top-15" :style="{'background-color': publicPageColorsDict.background_color.color }" @click="goTopage(application)">Läs mer och anmäl intresse</button>
                        </div>
                    </div>              
                </div>    
            </div>              
        </div>
   </section>
</template>
<style scoped>
    .OpenApplications-btn{
        background-color: rgb(181, 205, 191);
    padding: 10px 20px;
    font-size: 21px;
    color: black;
    border: 0px solid lightgray;
    font-family: 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    cursor: pointer;
    }
    
    .OpenApplications-filter-section {     
        padding: 1px 20px 20px 20px;
    }

    .OpenApplications-btn:hover {
        filter: brightness(0.8);
    }

    .OpenApplications-wrapper
    {
        display:flex;
        flex-wrap: wrap;
    }
    .OpenApplications-course-item
    {
        padding:10px; 
        margin: 20px;
        background: white;
        width: calc(33% - 60px);
        box-shadow: 1px 1px #ddd;
    }

    .OpenApplications-course-img-area
    {
        height: 250px; 
        overflow: hidden;
        text-align: center;
        display: flex;
        align-items: flex-end;
    }

    .OpenApplications-description
    {
        margin: 30px 10px 10px 10px;
        overflow:auto;
    }
    
    .OpenApplications-description i
    {
        display: -webkit-box;
        -webkit-line-clamp: 7;   /* no of rows */
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .OpenApplications-course-wrapper
    {
        display:flex;
        flex-wrap: wrap;

    }

    .OpenApplications-course-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        width: 100%;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
    }

    
.ImageGallery-grayscale {
    filter:grayscale(80%);
    transition: ease-out 0.2s;
}

.ImageGallery-no-grayscale {
    filter:grayscale(0%);
    transition: ease-out 0.2s;
}

    @media only screen and (max-width: 1000px) {
        .OpenApplications-course-img-area {
            height: auto;
            width: auto;
        }
        
        .OpenApplications-course-item
        {
            padding:10px; 
            margin: 00px 0px 30px 0px;
            width: calc(100% - 20px);
        }       
    }
</style>